import { features } from "@/mocks/anime";

const accentClasses = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
];

export default function Features() {
  return (
    <section id="feature" className="section-pad">
      <div className="container-site">
        <div className="mx-auto max-w-xl text-center">
          <span className="text-xs font-medium uppercase tracking-widest text-accent-600">Why Us</span>
          <h2 className="mt-1 font-heading text-3xl md:text-4xl">为连续追番而生的播放体验</h2>
          <p className="mt-3 text-sm text-foreground-600">
            免费高清、无广告、秒开流畅、一键连播，从打开到看爽只差一次点击。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-2xl border border-background-200 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 card-shadow"
            >
              <span className={`grid h-14 w-14 items-center justify-center rounded-2xl text-2xl transition-transform duration-300 group-hover:scale-110 ${accentClasses[features.indexOf(f) % accentClasses.length]}`}>
                <i className={f.icon} />
              </span>
              <h3 className="mt-4 font-heading text-xl text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}